export interface BookBlockData {
  id: string;
  badge: string;
  title: string;
  desc: string;
  highlight?: string;
  chips: string[];
  note?: string;
  covers: string[];
  bg: string;
  accent: string;
  tone: 'light' | 'dark';
  feature?: boolean;
}

const COVER_SOFIA = 'https://cdn.magicpatterns.com/uploads/mWuxMqkfRN1b7hgPRSnQas/el_asesino_no_es_sofia.png';
const COVER_SOPICIDIOS_1 = 'https://cdn.magicpatterns.com/uploads/d7WVHRFcXCyefXTSByRecT/image.png';
const COVER_SOPICIDIOS_2 = 'https://cdn.magicpatterns.com/uploads/bvEMUpH6ACC4MWrvDrTYQy/SOPICIDIOS.webp';
const COVER_MURDOKU = 'https://cdn.magicpatterns.com/uploads/uQ8iEyyUoUxqkZm4STZ1gN/PORTADA_MURDOKU.webp';
const COVER_VIAJE = 'https://cdn.magicpatterns.com/uploads/9WL6bjUYpwm32hXAbrBtjR/MURDOKU_VIAJE_AL_PASADO.webp';
const COVER_SOPA_EX = 'https://cdn.magicpatterns.com/uploads/jXCrcuxhhiFGpBCpWew3WL/image.png';
const COVER_VERANO_1 = 'https://cdn.magicpatterns.com/uploads/jx4WmggbCvqFf9QW1w2LKX/image.png';
const COVER_VERANO_2 = 'https://cdn.magicpatterns.com/uploads/23H76MK37wJSJsNpmjNztb/image.png';
const COVER_ENIGMAS_PRO = 'https://cdn.magicpatterns.com/uploads/jtxCzvQi8LBWvkfvSe2sU7/image.png';
const COVER_ESCAPE = 'https://cdn.magicpatterns.com/uploads/q4CsytCahNQoiasWfg8SCT/image.png';
const COVER_MURDER = 'https://cdn.magicpatterns.com/uploads/pFZksNurknATmW6CoefkcV/image.png';
const COVER_ILUSTRADOS = 'https://cdn.magicpatterns.com/uploads/81Z86KDnNYHn9cBcRao5sW/image.png';

export const bookBlocks: BookBlockData[] = [{
  id: 'sofia',
  badge: 'MISTERIO DE INVESTIGACIÓN',
  title: '¿Podrás demostrar que Sofía es inocente?',
  desc: '47.700 sospechosos y 18 pistas. Cada pista descarta nombres hasta que solo queda el verdadero culpable.',
  highlight: '47.700 SOSPECHOSOS',
  chips: ['18 pistas', 'Una única solución'],
  covers: [COVER_SOFIA],
  bg: '#F7F1E3',
  accent: '#C62828',
  tone: 'dark'
}, {
  id: 'sopicidios',
  badge: 'SOPAS DE LETRAS CRIMINALES',
  title: 'El asesino está escondido entre las letras',
  desc: 'Buscá al asesino, el arma y la escena escondidos dentro de cada sopa de letras criminal.',
  highlight: '160 CASOS PARA RESOLVER',
  chips: ['160 casos', '4 niveles de dificultad', 'Soluciones incluidas'],
  note: 'Incluye Sopicidios 1 + Sopicidios 2.',
  covers: [COVER_SOPICIDIOS_1, COVER_SOPICIDIOS_2],
  bg: '#141110',
  accent: '#E07B1E',
  tone: 'light'
}, {
  id: 'murdoku',
  badge: 'LÓGICA + CRIMEN + MISTERIO',
  title: '160 crímenes para resolver usando solamente la lógica',
  desc: 'Sospechosos, habitaciones, objetos y pistas. Combiná la información, descartá posibilidades y descubrí quién fue.',
  highlight: '160 ACERTIJOS',
  chips: ['160 acertijos', 'Tablas de deducción', 'Soluciones incluidas'],
  note: 'Incluye Murdoku original + Murdoku Viaje al Pasado.',
  covers: [COVER_MURDOKU, COVER_VIAJE],
  bg: '#5E1A8A',
  accent: '#F97316',
  tone: 'light',
  feature: true
}, {
  id: 'sopa-ex',
  badge: 'AMOR · MENTIRAS · MISTERIOS',
  title: '50 casos para descubrir la verdad',
  desc: 'Infidelidades, relaciones y secretos: encontrá las pistas y descubrí qué ocurrió realmente.',
  highlight: '50 CASOS',
  chips: ['Pasatiempos', 'Misterios e infidelidades'],
  covers: [COVER_SOPA_EX],
  bg: '#E6117F',
  accent: '#FFE14D',
  tone: 'light'
}, {
  id: 'verano',
  badge: 'CRÍMENES ILUSTRADOS + PASATIEMPOS',
  title: 'Uno de ellos es el asesino',
  desc: 'Con cada enigma que resuelvas podrás descartar a un sospechoso. Si los resolvés todos, tendrás al culpable.',
  highlight: '+200 JUEGOS',
  chips: ['Crucigramas', 'Sopas de letras', 'Juegos de lógica', 'Laberintos', 'Acertijos', 'Y mucho más'],
  note: 'Incluye El Crimen del Verano 1 + 2.',
  covers: [COVER_VERANO_1, COVER_VERANO_2],
  bg: '#0F5132',
  accent: '#F5B301',
  tone: 'light'
}, {
  id: 'ilustrados',
  badge: 'INVESTIGÁ LA ESCENA',
  title: 'La respuesta está delante de tus ojos',
  desc: 'Examiná cada escena del crimen, encontrá las pistas y resolvé quién fue el responsable.',
  highlight: '12 CRÍMENES PARA RESOLVER',
  chips: ['12 casos', 'Escenas ilustradas', '+200 páginas'],
  covers: [COVER_ILUSTRADOS],
  bg: '#0B2C46',
  accent: '#F2C21D',
  tone: 'light'
}, {
  id: 'enigmas-pro',
  badge: 'KIT DE ACTIVIDADES',
  title: '30 juegos para convertirte en detective',
  desc: 'Un kit de actividades con misterios, códigos, pistas y enigmas para resolver.',
  highlight: '+30 JUEGOS',
  chips: ['Misterios y códigos', 'Actividades para resolver'],
  covers: [COVER_ENIGMAS_PRO],
  bg: '#173A47',
  accent: '#E8B93B',
  tone: 'light'
}, {
  id: 'escape',
  badge: 'ESCAPE ROOM EN CASA',
  title: 'Montá tu propio Escape Room',
  desc: '4 juegos de escape preparados para organizar y resolver desde casa.',
  highlight: '4 ESCAPE ROOMS',
  chips: ['2 a 5 jugadores', 'Para montar en casa', 'Juegos completos'],
  covers: [COVER_ESCAPE],
  bg: '#0D0D0D',
  accent: '#C8A06A',
  tone: 'light'
}, {
  id: 'murder',
  badge: 'PARA GRANDES DETECTIVES',
  title: 'Más de 90 enigmas reservados para grandes detectives',
  desc: 'Acertijos, puzles y enigmas de lógica diseñados para investigar, deducir y resolver cada caso.',
  highlight: '+90 DESAFÍOS',
  chips: ['Puzles', 'Enigmas de lógica'],
  covers: [COVER_MURDER],
  bg: '#F5EBD8',
  accent: '#B01C22',
  tone: 'dark'
}];
